/**
 * @generated SignedSource<<0a581fd34c6b82402408c9521aba1d7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type processDefinitionQueryIncidentFragment$data = {
  readonly activityId: string | null | undefined;
  readonly failedActivityId: string | null | undefined;
  readonly incidentMessage: string | null | undefined;
  readonly incidentTimestamp: any | null | undefined;
  readonly incidentType: string | null | undefined;
  readonly processDefinitionId: string | null | undefined;
  readonly processInstanceId: string | null | undefined;
  readonly " $fragmentType": "processDefinitionQueryIncidentFragment";
};
export type processDefinitionQueryIncidentFragment$key = {
  readonly " $data"?: processDefinitionQueryIncidentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"processDefinitionQueryIncidentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "processDefinitionQueryIncidentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processDefinitionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processInstanceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failedActivityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incidentMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incidentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incidentTimestamp",
      "storageKey": null
    }
  ],
  "type": "ProcessDefinitionIncident",
  "abstractKey": null
};

(node as any).hash = "21e6c24ec0f37014fcad31828b44ca2b";

export default node;
